import { useEffect, useState } from "react";
import ContentWrapper from "../../views/components/ContentWrapper";
import { getHistory } from "../../data/dataApi";
import Pagination from "../../views/components/Pagination";
import { useNavigate, useParams } from "react-router";

const History = () => {
    const { page } = useParams();

    const [history, setHistory] = useState([]);
    const navigate = useNavigate();

    const listLimit = 30;

    useEffect(() => {
        (async () => {
            const response = await getHistory(page - 1 || 0);
            
            if(response.success) {
                setHistory(response.data.rows);
            }
        })();
    }, [page]);

    const handleNavigate = (sessionId) => {
        navigate(`/history/${sessionId}`);
    }

    return(
        <ContentWrapper className="scrollable">
            <div className="wrapper">
                <div className="table-wrapper">
                    <table className="primary-table">
                        <thead>
                            <tr>
                                <td>ID</td>
                                <td className="text-truncate">Message</td>
                                <td>Date</td>
                                <td>Time</td>
                                <td>Country</td>
                                <td>User IP</td>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                history.map((entry) =>
                                    <tr key={ entry.id } onClick={() => handleNavigate(entry.session_id)}>
                                        <td>{ entry.id }</td>
                                        <td className="text-truncate">{ entry.user_message }</td>
                                        <td>{ new Date(entry.time).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) }</td>
                                        <td>{ new Date(entry.time).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' }) }</td>
                                        <td>{ entry.country }</td>
                                        <td>{ entry.user_ip }</td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>

                    <Pagination listLength={ history.length && history[0].total_count } path="/history" page={ page } limit={ listLimit } />
                </div>
            </div>
        </ContentWrapper>
    );
};

export default History;